import { DOCUMENT } from '@angular/common';
import { Component, OnInit,Inject,Input, ComponentFactoryResolver, Output, EventEmitter, OnDestroy,ViewChild, ElementRef, ChangeDetectorRef} from '@angular/core';
import {FormBuilder,FormControl, FormGroup,Validators,FormsModule} from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, ActivatedRoute, ParamMap,RoutesRecognized } from '@angular/router';
import { AuthenticationService, LoggerService, EwCommonService,statusCodes ,FlashService } from 'ew-common-lib';
import { ListSelectIntegrationComponent } from '../select-list-integration/select-list-integration.component';
import {EwMaIntegrationService } from '../ew-ma-integration.service';
import { DeleteConfirmationComponent } from '../delete-confirmation/delete-confirmation.component';

import { TranslateService } from '@ngx-translate/core';
import { EwMaIntegrationTranslateService } from '../services/ew-ma-integration-translate.service';
import { MatSelect } from '@angular/material/select';
import { IntegrationformComponent } from '../integrationform/integrationform.component';

@Component({
  selector: 'lib-add-itegration',
  templateUrl: './add-itegration.component.html',
  styleUrls: ['./add-itegration.component.css']
})
export class AddItegrationComponent implements OnInit {
 private contentPlaceholder:any;
 @ViewChild(IntegrationformComponent, {static : true}) IntegrationformComponent : IntegrationformComponent;
 @ViewChild('mySelect', { static: false }) set content(content: ElementRef) {
  if(content) { // initially setter gets called with undefined
      this.contentPlaceholder = content;
  }
}
  wasClicked: boolean = false;
  selected = 'option1';
  addInetgrationOption: boolean = false;
  allTags:any;
  allList:[]  ;
  campaigns:any;
  allcustomFields:any;
  webinarCustomFields:any;
  offersTagging:any;
  actions:any;
  events:any;
  selectedEvent = '';
  selectedAction = '0' ;
  showLoader = 1;
  customFieldLoader = 0;
  selectedValue :any;
  selectedOffer :any;
  webinar_integration_details :any;
  webinar_integration_tags :any;
  offers :any;
  webinar_integration_custom_fields :any;
  minutesRange:any;
  hoursRange:any;
  selectedHours:number=0;
  selectedMinutes:number=0;
  selectedCustomfield:any;
  selectedWebinarCustomfield:any;
  selectedAdvaceField:any;
  buttonText = 'Save';
  customButtonText = 'Save Changes';
  customFieldType = 1; //1 for select box,0 for text box
  tagsType = 1;  //1 for select box,0 for text box
  selectedList:string;
  showchangelistOption = false;
  affiliates:any;
  showGdpr = 0;
  gdprSettingsSaved = 0;
  gdprSettings:any;
  existingEvent:any;
  myForm: FormGroup;
  @Input() serviceName : string;
  @Input() default_lang = 'en';
  disableEvents:boolean = false;
  @Input() event_id:string;
 // event_id = 879;
  transLationMessages:any;   
  gotit_button_text = 'Got it'; 
  @Output() exit: any = new EventEmitter();
  showEditButton = 1;
  offerstags=[];
  constructor(
    @Inject(DOCUMENT) private _document: any,
    private EwMaIntegrationService: EwMaIntegrationService,
    private authenticationService: AuthenticationService,
    public dialog: MatDialog,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private ewFlashService: FlashService,
    private fb: FormBuilder,
    private ewTranslateService: EwMaIntegrationTranslateService,
    public translate: TranslateService,
    private changeDetector : ChangeDetectorRef,
    private ewCommonService: EwCommonService
    ) {
      translate.addLangs(["en", "es"]);
    }

    showDiv = {
      previous: false
    };

  ngOnInit(): void { 
    this.initLanguage();

    this.serviceName = this.activatedRoute.snapshot.params.service_provider;
    if(!this.serviceName){ 
      this.exit.emit();
      // this.router.navigate(['./integration']);
    }
    this.transLationMessages = this.translate.store.translations[this.default_lang];
        
    if(this.serviceName == 'mailchimp' || this.serviceName == 'icontact' || this.serviceName == 'activecampaign' || this.serviceName == 'drip'){ 
      this.customFieldType = 0;
    }
    else{ 
      this.customFieldType = 1;
    }

    if( this.serviceName == 'icontact' || this.serviceName == 'hubspot'  || this.serviceName == 'pardot'){ 
      this.actions = {'addlist':this.transLationMessages.SELECT_ACTIONS.ADDTOLIST,'removelist':this.transLationMessages.SELECT_ACTIONS.REMOVE_FROM_LIST};
    } else if (this.serviceName == 'infusionsoft' || this.serviceName == 'convertkit' ||  this.serviceName == 'getresponse'){
      this.actions = {'addtag':this.transLationMessages.SELECT_ACTIONS.ADDTAG,'removetag':this.transLationMessages.SELECT_ACTIONS.REMOVETAG};
    }
    else{ 
REMOVE_FROM_LIST: "Remove from list"
      this.actions = {'addtag':this.transLationMessages.SELECT_ACTIONS.ADDTAG,'removetag':this.transLationMessages.SELECT_ACTIONS.REMOVETAG,'addlist':this.transLationMessages.SELECT_ACTIONS.ADDTOLIST,'removelist':this.transLationMessages.SELECT_ACTIONS.REMOVE_FROM_LIST};
    }

    if(this.serviceName == 'mailchimp' || this.serviceName == 'influencersoft'){
      this.tagsType = 0;
    }else{
      this.tagsType = 1;
    }
    this.hoursRange = Array(8).fill(0).map((x,i)=>i);
    this.minutesRange = Array(60).fill(0).map((x,i)=>i);
    this.selectedCustomfield = {};
    this.selectedWebinarCustomfield = {};    
    //this.transLationMessages = this.translate.store.translations[this.default_lang];
    this.gotit_button_text = this.transLationMessages.SNACKBAR_TEXT.GOT_IT_BUTTON;
    this.events = {"api_registered_tag":{"name":this.transLationMessages.EVENTS.REGISTERED,"status":1},"api_came_tag":{"name":this.transLationMessages.EVENTS.ATTENDED,"status": 1},"api_didnt_came_tag":{"name":this.transLationMessages.EVENTS.MISSED,"status":1},"api_watched_replay_tag":{"name":this.transLationMessages.EVENTS.WATCHED_REPLAY,"status":1}
    ,"api_replay_not_watched_tag":{"name":this.transLationMessages.EVENTS.DID_NOT_WATCHED_REPLAY,"status":1},"api_joined_webinar_after_tag":{"name":this.transLationMessages.EVENTS.JOIN_WEBINAR_AFTER,"status":1},"api_left_webinar_before_tag":{"name":this.transLationMessages.EVENTS.LEFT_WEBINAR_BEFORE,"status":1}
    ,"api_left_early_tag":{"name":this.transLationMessages.EVENTS.LEFT_EARLY,"status":1},"api_stayed_event_atleast_tag":{"name":this.transLationMessages.EVENTS.STAY_ON_WEBINAR_AT_LEAST,"status":1},"api_watched_full_tag":{"name":this.transLationMessages.EVENTS.WATCHED_FULL,"status":1},"api_delayed_clicked_tag":{"name":this.transLationMessages.EVENTS.OFFER_CLICKED,"status":1}
    ,"api_delayed_tag":{"name":this.transLationMessages.EVENTS.SAW_BUT_NOT_CLICKED,"status":1},"api_question_asked":{"name":this.transLationMessages.EVENTS.QUESTION_ASKED,"status":1}};
    this.getIntegtaionAllData();
     this.myForm = this.fb.group({
      event:['', Validators.required],
      action: ['', Validators.required],
      value: ['', Validators.required],
      selectedHours:[''],
      selectedMinutes: [''],
      selectedOffer: [''],
      searchList:['testing search']
    });

this.myForm.get('event').valueChanges
  .subscribe(value => {
    if(value == 'api_joined_webinar_after_tag' || value == 'api_stayed_event_atleast_tag'  || value == 'api_left_webinar_before_tag') {
      this.myForm.get('selectedHours').setValidators(Validators.required);
      this.myForm.get('selectedMinutes').setValidators(Validators.required);
    } else {
      this.myForm.get('selectedHours').setValidators([]);
      this.myForm.get('selectedMinutes').setValidators([]);      
    }
    this.myForm.get('selectedHours').updateValueAndValidity;
    this.myForm.get('selectedMinutes').updateValueAndValidity();
  });
}
  
  initLanguage() {
    this.translate.setDefaultLang(this.default_lang);
    
    this.translate.use(this.default_lang).subscribe(() => {
      this.ewTranslateService.init();
    });
  }

  /**
   * @description
   * Fetch all integration listing from API
   */
       public getIntegtaionAllData(): void { 
        this.showLoader = 1; 
        const model = {
          webinar_id: this.event_id,
          service_provider:this.serviceName
        };
        this.EwMaIntegrationService.getIntegtaionAllData(model).subscribe(
          (response: any) => { 
            this.showLoader = 0;
            if (response.status.code == statusCodes.SUCCESS) { 
              this.allList = response.data.contact_list;
              this.allTags = response.data.tags;
              this.showGdpr = response.data.show_gdpr;
              this.allcustomFields = response.data.custom_fields;
              this.campaigns = response.data.campaigns;
              this.offers = response.data.offers;
              this.offersTagging = response.data.offers;
              this.selectedList = response.data.selected_list;
              if(this.showGdpr == 1){
                this.events = {"api_gdpr_tag":{"name":this.transLationMessages.EVENTS.GDPR_EXCLUDE_LIST,"status":1},"api_registered_tag":{"name":this.transLationMessages.EVENTS.REGISTERED,"status":1},"api_came_tag":{"name":"Attended","status": 1},"api_didnt_came_tag":{"name":"Missed","status":1},"api_watched_replay_tag":{"name":"Watched replay","status":1}
                ,"api_replay_not_watched_tag":{"name":"Didn't Watched Replay","status":1},"api_joined_webinar_after_tag":{"name":"Joined webinar after","status":1},"api_left_webinar_before_tag":{"name":"Left webinar before","status":1}
                ,"api_left_early_tag":{"name":"Left Early","status":1},"api_stayed_event_atleast_tag":{"name":"Stayed on webinar at least","status":1},"api_watched_full_tag":{"name":"Watched full","status":1},"api_delayed_clicked_tag":{"name":"Clicked Offer","status":1}
                ,"api_delayed_tag":{"name":"Saw offer but didn't click","status":1},"api_question_asked":{"name":"Question asked","status":1}};
              }
              if((this.serviceName == 'mailchimp' || this.serviceName == 'getresponse' || this.serviceName == 'convertkit') && !this.selectedList){ // In case of mailchimp if no  list selected redirect to integration
                this.exit.emit();
                // this.router.navigate(['./integration']);
              }
              if(this.serviceName == 'aweber' && response.data.selected_list ){
                this.actions = {'addtag':'Add Tag','removetag':'Remove Tag','addlist':'Add To List','removelist':'Remove from list'};
                this.customFieldType = 1;
                this.tagsType = 0;
              }
              if(this.serviceName == 'aweber' && !response.data.selected_list ){
                this.actions = {'addlist':'Add To List','removelist':'Remove from list'};
                this.customFieldType = 0;
              }
              if(this.serviceName == 'infusionsoft' ){
                this.affiliates = response.data.affiliates;
              }
              if(response.data.webinar_custom_fields.record_exist == 1){ 
                this.webinarCustomFields = response.data.webinar_custom_fields.webinar_custom_fields;
                for (let prop in this.webinarCustomFields) {
                  this.selectedWebinarCustomfield[prop] = this.webinarCustomFields[prop]['merge_field'];
                }
              }
              this.webinar_integration_details = response.data.webinar_integration_details;
              console.log("this====", this.webinar_integration_details);
              if(this.webinar_integration_details != undefined && this.webinar_integration_details.tags){ 
                
                this.webinar_integration_tags = this.webinar_integration_details.tags;
                for (let prop in this.webinar_integration_tags) { 
                  if(this.showGdpr == 1 && prop == 'api_gdpr_tag'){
                    this.gdprSettingsSaved = 1;
                    this.gdprSettings = this.webinar_integration_tags[prop]; 
                  }
                   this.events[prop]['status'] = 0;
                }
              }

              if(this.webinar_integration_details != undefined && this.webinar_integration_details.custom_fields){
                this.selectedCustomfield = this.webinar_integration_details.custom_fields;
              }else{
                this.selectedCustomfield = {};
              }
              if(this.offers != ''){
                for (let prop in this.offers){
                  if(this.offers[prop]['tags'] != ''){
                    for (let off in this.offers[prop]['tags']){                      
                      this.offerstags[off+'_'+this.offers[prop]['id']] = 1;
                    }
                  }
                }
              }

            }else if (response.status.code == statusCodes.NOT_FOUND) {
              this.allList = [];
              this.allTags = [];
              this.allcustomFields = [];
              this.campaigns = [];
              this.offers = [];
              this.webinar_integration_tags = [];
            }
           
          },
          (error) => {
            this.showLoader = 0;
            console.log('error', error);
          }
        );
      }


      //#design end methods
      sideNav() {
        if (this.wasClicked) {
          this._document.body.classList.remove('sidebar_open');
        } else {
          this._document.body.classList.add('sidebar_open');
        }
        this.wasClicked = !this.wasClicked;
      }

      integrationOption1(){
       // this.myForm.reset();
       // this.addInetgrationOption = !this.addInetgrationOption;
      }
      keepOrder = (a, b) => {
       // return a;
       return (parseInt(a.key) > parseInt(b.key))?1:0;
      }


      public conditionChanged($event){
        if($event.value == 'api_joined_webinar_after_tag' || $event.value == 'api_stayed_event_atleast_tag'  || $event.value == 'api_left_webinar_before_tag') {
          this.myForm.get('selectedHours').setValidators(Validators.required);
          this.myForm.get('selectedMinutes').setValidators(Validators.required);
          this.myForm.get('selectedHours').updateValueAndValidity();   
          this.myForm.get('selectedMinutes').updateValueAndValidity();   
        } else if($event.value == 'api_joined_webinar_after_tag' || $event.value == 'api_stayed_event_atleast_tag'){

        }else { 
          this.myForm.get('selectedHours').setValidators([]);
          this.myForm.get('selectedMinutes').setValidators([]);   
          this.myForm.get('selectedHours').updateValueAndValidity();   
          this.myForm.get('selectedMinutes').updateValueAndValidity();   
        } 
      }

/**
  * @description
  * Delete selected Tag/list
  */
 public confirmDelete(integration_action:string,selected_offer:number): void {

  const dialogRef = this.dialog.open(DeleteConfirmationComponent, {
    maxWidth: '500px',
    width: '100%',
    panelClass: 'confrimation-delete'
  });
  this.ewCommonService.addPopupCustomClass("full-screen-black-dialog");
  dialogRef.afterClosed().subscribe((result) => {  
    this.ewCommonService.removePopupCustomClass("full-screen-black-dialog");
    if (result) {
      this.removeSelectedTag(integration_action,selected_offer);
    }
  });
  
}

/**
* @description
* Remove selected Integration
*/
public removeSelectedTag(integration_action:string,selected_offer:number): void { 
  this.showLoader = 1;
  const model = {
    event_id: this.event_id,
    event:integration_action,
    offer_id:selected_offer,
  };

  this.EwMaIntegrationService.removeSelectedTag(model).subscribe(
    (response: any) => {
      this.showLoader = 0;
      if (response.status.code == statusCodes.SUCCESS) {
        this.events[integration_action]['status'] = 1;
        if(integration_action == 'api_delayed_clicked_tag' || integration_action == 'api_delayed_tag'){ 

          for (let i = 0; i < this.offersTagging.length; i++) {
            if(this.offersTagging[i]['id'] == selected_offer ){
              if( Object.keys(this.offersTagging[i]['tags']).length){ 
                delete  this.offersTagging[i]['tags'][integration_action];                        
              }
              break;
            }
          }
          
        }else{
          delete this.webinar_integration_tags[integration_action];
        }  
        this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.DATA_UPDATED_SUCC_MSG,this.gotit_button_text);      
      }else{
        this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.SOMETHING_WENT_WRONG,this.gotit_button_text,"error-ew-message");
      }
    },
    (error) => {
      this.showLoader = 0;
      console.log('error', error);
     
    }
  );
  
}

/**
  * @description
  * Disconnect Integration
  */
 public disconnectIntegration(): void {
  const dialogRef = this.dialog.open(DeleteConfirmationComponent, {
    maxWidth: '500px',
    width: '100%',
    panelClass: 'confrimation-delete'
  });
  this.ewCommonService.addPopupCustomClass("full-screen-black-dialog");
  dialogRef.afterClosed().subscribe((result) => {
    this.ewCommonService.removePopupCustomClass("full-screen-black-dialog");
      if (result) {
        this.disconnectIntegrationForEvent();
      }
    
  });
}

/**
* @description
* Disconnect Integration
*/
public disconnectIntegrationForEvent(): void { 

  const model = {
    event_id: this.event_id
  };
  this.EwMaIntegrationService.disconnectIntegrationForEvent(model).subscribe(
    (response: any) => {
      if (response.status.code == statusCodes.SUCCESS) { 
        this.allList = [];
        this.allTags = [];
        this.allcustomFields = [];
        this.campaigns = [];
        this.webinar_integration_tags = [];
        this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.DATA_UPDATED_SUCC_MSG,this.gotit_button_text);
        this.exit.emit();
        // this.router.navigate(['./integration']);
      }else{
        this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.SOMETHING_WENT_WRONG,this.gotit_button_text,"error-ew-message");
      }
    },
    (error) => {
      console.log('error', error);
      this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.SOMETHING_WENT_WRONG,this.gotit_button_text,"error-ew-message");
    }
  );
  
}

/*
Function to redirect to
*/
public changeIntegration(){
  this.exit.emit();
  // this.router.navigate(['./integration']);
}


saveCustomfields(){
  const model = {
    event_id: this.event_id,
    service_provider:this.serviceName,
    custom_feilds:this.selectedCustomfield
  };
  this.customFieldLoader = 1;

  this.EwMaIntegrationService.saveCustomFields(model).subscribe(
    (response: any) => {  
      this.customFieldLoader = 0;
      if (response.status.code == statusCodes.SUCCESS) { 
        this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.DATA_SAVED_SUCC_MSG,this.gotit_button_text);
      }else{
        this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.SOMETHING_WENT_WRONG,this.gotit_button_text,"error-ew-message");
      }
    },
    (error) => {
      this.customFieldLoader = 0;
      console.log('error', error);
      this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.SOMETHING_WENT_WRONG,this.gotit_button_text,"error-ew-message");
    }
  );
}


/**
 * SAve advance custom fields
 */

 saveWebinarCustomFields(){

  const model = {
    event_id: this.event_id,
    service_provider:this.serviceName,
    custom_feilds:this.selectedWebinarCustomfield
  };
  this.customFieldLoader = 1;
  this.EwMaIntegrationService.saveWebinarCustomFields(model).subscribe(
    (response: any) => {
      this.customFieldLoader = 0;
      if (response.status.code == statusCodes.SUCCESS) { 
        this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.DATA_SAVED_SUCC_MSG,this.gotit_button_text);
      }else{
        this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.SOMETHING_WENT_WRONG,this.gotit_button_text,"error-ew-message");
      }
    },
    (error) => {
      this.customFieldLoader = 0;
      console.log('error', error);
      this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.SOMETHING_WENT_WRONG,this.gotit_button_text,"error-ew-message");
    }
  );

 }

 public relaodTagsListCustomfields(){
      const model = {
        service_provider:this.serviceName,
      };
      this.showLoader = 1;
      this.EwMaIntegrationService.relaodTagListCustomFields(model).subscribe(
        (response: any) => {
          this.showLoader = 0;
          if (response.status.code == statusCodes.SUCCESS) { 

            this.allList = response.data.contact_list;
            this.allTags = response.data.tags;
            this.allcustomFields = response.data.custom_fields;
            if(this.serviceName == 'aweber' && this.selectedList != ''){
              for (let i = 0; i < this.allcustomFields.length; i++) {
                if(this.allcustomFields[i]['list_id'] == this.selectedList ){
                  let listCustomFields = this.allcustomFields[i]['custom_fields'];
                  let fields = [];
                  for (let j = 0; j < listCustomFields.length; j++){                    
                    //let test = listCustomFields[j]['name'];                
                    fields[listCustomFields[j]['name']] = listCustomFields[j]['name'];
                  }
                  this.allcustomFields = fields;
                  break;
                }
              }
            }
            this.campaigns = response.data.campaigns;
            this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.DATA_UPDATED_SUCC_MSG,this.gotit_button_text);
          }else{
            this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.SOMETHING_WENT_WRONG,this.gotit_button_text,"error-ew-message");
            this.allList = [];
            this.allTags = [];
            this.allcustomFields = [];
            this.campaigns = [];
          }
        },
        (error) => {
          this.showLoader = 0;
          console.log('error', error);
          this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.SOMETHING_WENT_WRONG,this.gotit_button_text,"error-ew-message");
        }
      );
 }

 closeIntegrationForm(){ 
  this.myForm.reset();
  this.selectedEvent='';
  this.existingEvent = '';
  this.addInetgrationOption=!this.addInetgrationOption;
  if(this.webinar_integration_details.tags){ 
    this.showLoader = 0;
    this.webinar_integration_tags = this.webinar_integration_details.tags;
    for (let prop in this.webinar_integration_tags) {
       this.events[prop]['status'] = 0;
    }
  }
 }

 
 listChangeOption(){ 
let customfieldAlert = this.serviceName == 'aweber'?1:0;
  const dialogRef = this.dialog.open(ListSelectIntegrationComponent, {
    maxWidth: '555px',
    width: '100%',
    backdropClass: 'ew-new-backdrop',
    panelClass:'ew-new',  
    data:{service_provider:this.serviceName,list:this.allList,event_id:this.event_id,customFieldAlert:customfieldAlert}
  });
  this.ewCommonService.addPopupCustomClass("full-screen-black-dialog");
  dialogRef.afterClosed().subscribe((result) => {
    this.ewCommonService.removePopupCustomClass("full-screen-black-dialog");
    if (result) { 
      this.getIntegtaionAllData();
    }
  });

  return;



  this.showchangelistOption = !this.showchangelistOption;
  this.changeDetector.detectChanges();
  const newLocal = this.contentPlaceholder;
  newLocal.open();
 }

 fetchCustomFields($event){ 
   let custom_fields = this.serviceName == 'aweber'?1:0;
   this.showLoader = 1;
   const  model = {
    'service_provider':this.serviceName,
    'action':"list",
    'value':this.selectedList,
    'event_id':this.event_id,
    'custom_fields':custom_fields,
   };
   this.EwMaIntegrationService.saveSelectedList(model).subscribe(
     (response: any) => { 
      this.showLoader = 0;
       if (response.status.code == statusCodes.SUCCESS) {   
        this.showchangelistOption = !this.showchangelistOption; 
          if(this.serviceName == 'aweber'){
            this.allcustomFields = response.data.custom_fields;
          } 
       }
       this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.DATA_UPDATED_SUCC_MSG,this.gotit_button_text);
     },
     (error) => { 
      this.showLoader = 0;
       this.ewFlashService.openSnackBar(this.transLationMessages.SNACKBAR_TEXT.SOMETHING_WENT_WRONG,this.gotit_button_text,"error-ew-message");
     }
   );
 }

 activeTabCustom = 'defaultField';

 defaultField(activeTab){
   this.activeTabCustom = activeTab;
 }

 customField(activeTab){
   this.activeTabCustom = activeTab;
 }

 showHideEditButtons(value){ 
    //this.showEditButton = value;
    this.addInetgrationOption = value;
 }

}